import React, { useState, useEffect } from "react";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import MyVerticallyCenteredModal from "../imgUpload/modal";
import {
  getAllImages,
  getAppParams,
  editPage,
  getPage,
  getImagesById,
  getElement,
  getAllElementsByType,
  publishPage,
  unpublishPage,
  redraftPage,
  republishPage,
  requestPublish,
} from "../../api/api";
import LabelImage from "../cards/image";
import TextList from "../list/textList";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import { parseISOString } from "../../api/common";
import { NecStore } from "../../store/necStore";
import { UserLang, UserStore } from "../../store/userStore";
import ToolTip from "../tooltip/tooltip";

const TextPage = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [allImage, setallImage] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [store, setStore] = useState([]);
  const role = NecStore.useState((s) => s.setting);
  const lan = UserLang.useState((s) => s.lan);
  const user = UserStore.useState((s) => s.user);
  const dev = [
    {
      itemName: "web",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "android",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "iOS",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "appletv",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "androidtv",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "firetv",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "roku",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "tizen",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "webos",
      itemSize: "",
      itemVisibility: null,
    },
    {
      itemName: "chromecast",
      itemSize: "",
      itemVisibility: null,
    },
  ];
  const obj = {
    images: {
      application: "",
      createdBy: "",
      date: "",
      imageName: "",
      imagekey: "7c3b33e3ea0fad6532b3763896398d30",
    },
  };
  const [device, setDevice] = useState(dev);
  const [portrait, setPortrait] = useState(obj);
  const [landscape, setLandscape] = useState(obj);
  const [banner, setBanner] = useState(obj);

  /* eslint-disable no-unused-vars */
  const [recElem, setRecElem] = useState("");
  const [allPage, setallPage] = useState([]);

  /* eslint-disable no-unused-vars */

  const page = {
    pageType: "textPage",
    referenceName: "",
    urlName: "",
    displayName: "",
    portraitThumbnail: "",
    landscapeThumbnail: "",
    bannerImage: "",
    devices: device,
    items: list,
    draftStatus: true,
    publishStatus: false,
    republishStatus: false,
    audio: "",
    starring: "",
    rating: "",
    genre: "",
    contentType: "",
    director: "",
    producer: "",
    studio: "",
    description: "",
    writer: "",
    recommendation: "",
  };
  const [pager, setPage] = useState(page);

  useEffect(() => {
    const getImage = async () => {
      try {
        const appl = await getAllImages(100, 0);

        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.imagekey,
          label: (
            <LabelImage
              url={getAppParams() + item.imagekey}
              name={item.imageName}
            ></LabelImage>
          ),
          key: item.imagekey,
          name: item.imageName,
          id: item._id,
        }));

        setallImage(opt);
      } catch (error) {}
    };
    const pageDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const pageid = props.match.params.id;
      const result = await getPage(pageid).then(
        (result) => {
          brandImage(result.data);
          setPage(result.data);
          setLoading(false);
        },
        (error) => {
          toastr.error("Unable to Load Data", "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const getPaged = async () => {
      try {
        const appl = await getAllElementsByType(200, 0, "portraitSlider");

        const pages = appl.data.elements;

        const imageCount = appl.data.count;

        const opt = pages.map((item) => ({
          value: item._id,
          label: item.referenceName,
        }));
        setallPage(opt);
      } catch (error) {}
    };

    const brandImage = async (editing) => {
      /* eslint-disable no-unused-vars */

      const temp_dev = editing.devices;
      /*eslint-disable no-useless-computed-key */
      setPage(editing);
      /*eslint-disable no-useless-computed-key */
      setDevice([...temp_dev]);

      /* eslint-disable no-unused-vars */

      const result = await getImagesById(editing.portraitThumbnail).then(
        (result) => {
          setPortrait(result.data);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
      /* eslint-disable no-unused-vars */
      const resulted = await getImagesById(editing.landscapeThumbnail).then(
        (result) => {
          setLandscape(result.data);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
      /* eslint-disable no-unused-vars */
      const results = await getImagesById(editing.bannerImage).then(
        (result) => {
          setBanner(result.data);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
      const resul = await getElement(editing.recommendation).then(
        (result) => {
          setRecElem(result.data.referenceName);
        },
        (error) => {}
      );
    };
    getImage();
    pageDetail();
    getPaged();
  }, [
    props.match.params.id,
    store.draftStatus,
    store.publishStatus,
    store.republishStatus,
  ]);

  const setNotifications = async (editing) => {
    setLoading(true);
    /* eslint-disable no-unused-vars */
    const pageid = props.match.params.id;
    const result = await requestPublish(editing).then(
      (result) => {
        // brandImage(result.data);
        // setPage(result.data);
        setLoading(false);
      },
      (error) => {
        toastr.error("Unable to Load Data", "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const handlePublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: pager.pageType,
      itemid: pager._id,
      redirect: "page",
      message: "Content Editor requested to Publish " + pager.displayName,
    };

    setNotifications(opt);
  };

  const handleUnpublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: pager.pageType,
      itemid: pager._id,
      redirect: "page",
      message: "Content Editor requested to Unpublish " + pager.displayName,
    };

    setNotifications(opt);
  };

  const handleRepublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: pager.pageType,
      itemid: pager._id,
      redirect: "page",
      message: "Content Editor requested to Republish " + pager.displayName,
    };

    setNotifications(opt);
  };

  const filterOption = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  const handleChange = (evt) => {
    const value = evt.target.value;

    setPage({
      ...pager,
      [evt.target.name]: value,
    });
  };

  const onChangeItem = (value, evt) => {
    setPage({
      ...pager,
      [evt.name]: value.id,
    });

    const temp_obj = {
      images: {
        application: "",
        createdBy: "",
        date: "",
        imageName: value.name,
        imagekey: value.key,
      },
    };

    evt.name === "portraitThumbnail"
      ? setPortrait(temp_obj)
      : evt.name === "landscapeThumbnail"
        ? setLandscape(temp_obj)
        : setBanner(temp_obj);
  };
  const draft = async (event) => {
    setLoading(true);
    event.preventDefault();

    const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */

    const result = await editPage(pager, pageid).then(
      (result) => {
        setStore(result.data);

        toastr.success("Successfully Saved", "Success");
        setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const redraft = async (event) => {
    setLoading(true);
    event.preventDefault();

    const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */

    const result = await redraftPage(pager, pageid).then(
      (result) => {
        setStore(result.data);

        toastr.success("Successfully Saved", "Success");
        setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const publish = async (event) => {
    // setDisable(true);
    if (role.production === true) {
      setLoading(true);
      event.preventDefault();

      const pageid = props.match.params.id;

      /* eslint-disable no-unused-vars */
      const result = await publishPage(pageid).then(
        (result) => {
          setStore(result.data);

          toastr.success("Successfully Published", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  const republish = async (event) => {
    // setDisable(true);
    setLoading(true);
    event.preventDefault();

    const pageid = props.match.params.id;

    /* eslint-disable no-unused-vars */
    const result = await republishPage(pageid).then(
      (result) => {
        setStore(result.data);

        toastr.success("Successfully Published", "Success");
        setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const unpublish = async (event) => {
    // setDisable(true);
    // setLoading(true);
    event.preventDefault();

    const pageid = props.match.params.id;

    /* eslint-disable no-unused-vars */
    const result = await unpublishPage(pageid).then(
      (result) => {
        setStore(result.data);

        toastr.success("Successfully Unpublished", "Success");
        // setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        // setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const updateSize = (index, event) => {
    const newArray = device;
    newArray[index].itemSize = event.target.value;
    setDevice(newArray);
  };
  const updateVisiblity = (index, event) => {
    const newArray = device;
    newArray[index].itemVisibility = event.target.checked;
    setDevice(newArray);
  };
  const handleListChange = (edit) => {
    const opt = edit.map((item) => ({
      itemid: item.value,
      itemRef: item.label,
      itemOrder: item.order,
    }));
    setList(opt);
    /*eslint-disable no-useless-computed-key */
    setPage({
      ...pager,
      ["items"]: opt,
    });
    /*eslint-disable no-useless-computed-key */
  };
  const onChangePage = (value, evt) => {
    setPage({
      ...pager,
      [evt.name]: value.value,
    });
    setRecElem(value.label);
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Text Page
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={draft}>
                    <div className="row">
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Name used to identify this page on CMS"}
                              />
                            )}
                            &nbsp;Reference Name&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Name used to identify this page on CMS"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="referenceName"
                            className="form-control inside-form"
                            placeholder="Reference Name ..."
                            defaultValue={pager.referenceName}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip info={"Title name for the page"} />
                            )}
                            &nbsp;Display Name&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Title name for the page"}
                                place={"right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="displayName"
                            className="form-control inside-form"
                            placeholder="Display Name ..."
                            defaultValue={pager.displayName}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Intro paragraph for the text page"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Introduction&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Intro paragraph for the text page"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <textarea
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            name="description"
                            className="form-control inside-form"
                            placeholder="Description"
                            defaultValue={pager.description}
                            onChange={handleChange}
                            autoComplete="off"
                          ></textarea>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="row">
                            {lan === "rtl" && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Portrait image used in portrait elements"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Portrait Thumbnail&nbsp;
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Portrait image used in portrait elements"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="portraitThumbnail"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>

                              <div
                                className="row"
                                style={{
                                  marginTop: "100px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + portrait.images.imagekey
                                    }
                                    name={portrait.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            {!(lan === "rtl") && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="row">
                            {lan === "rtl" && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Landscape image used in Landscape elements"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Landscape Thumbnail&nbsp;
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Landscape image used in Landscape elements"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="landscapeThumbnail"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "100px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + landscape.images.imagekey
                                    }
                                    name={landscape.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            {!(lan === "rtl") && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="row">
                            {lan === "rtl" && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={"Banner image used in Banner field"}
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Banner Image&nbsp;
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={"Banner image used in Banner field"}
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="bannerImage"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "100px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + banner.images.imagekey
                                    }
                                    name={banner.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            {!(lan === "rtl") && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {lan === "rtl" && <div className="col-sm-6"></div>}
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip info={"Referral name used in pages"} />
                            )}
                            &nbsp;URL Name&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip info={"Referral name used in pages"} />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="urlName"
                            className="form-control inside-form"
                            placeholder="URL Name"
                            defaultValue={pager.urlName}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2 mt-2"></div>
                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {lan === "rtl" && (
                          <ToolTip
                            info={"Chose multiple text field for text page"}
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                        &nbsp;Text Container&nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={"Chose multiple text field for text page"}
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                      </label>
                    </div>
                    <TextList
                      dir={lan === "rtl" ? "rtl" : "ltr"}
                      onChange={handleListChange}
                      listData={pager.items}
                      {...props}
                    ></TextList>
                    <div className="row mb-2 mt-2"></div>
                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        Device Playlist Size
                      </label>
                    </div>
                    <div className="row mb-2 mt-2">
                      {pager.devices.map((image, index) => (
                        <div className="col-sm-6" key={index}>
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              {image.itemName}
                            </label>
                            <input
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              type="number"
                              name={image.itemName + "size"}
                              className="form-control inside-form"
                              placeholder="Add Size"
                              defaultValue={image.itemSize}
                              onChange={(event) => updateSize(index, event)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="row mb-2 mt-2"></div>

                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {lan === "rtl" && (
                          <ToolTip
                            info={
                              "Manually enable visibility in different platforms"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                        &nbsp;Devices to Display&nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={
                              "Manually enable visibility in different platforms"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                      </label>
                    </div>

                    <div className="row mb-2 mt-2">
                      {pager.devices.map((image, index) => (
                        <div className="col-sm-6" key={index}>
                          <div className="form-group">
                            <div className="custom-control custom-switch">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                name={"customSwitch" + index}
                                id={"customSwitch" + index}
                                defaultChecked={image.itemVisibility}
                                onClick={(event) =>
                                  updateVisiblity(index, event)
                                }
                              />
                              <label
                                className=" custom-control-label not-bold"
                                htmlFor={"customSwitch" + index}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {image.itemName}
                              </label>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        Information
                      </label>
                    </div>
                    <div className="row mb-2 mt-2"></div>

                    <div className="row mb-2 mt-2">
                      <div className="col-sm-6">
                        <div
                          className={
                            lan === "rtl"
                              ? "form-group float-right"
                              : "form-group float-left"
                          }
                        >
                          <div dir={lan === "rtl" ? "rtl" : "ltr"}>
                            Status:{" "}
                            <label
                              className={
                                pager.publishStatus && pager.draftStatus
                                  ? "badge badge-success"
                                  : "badge badge-danger"
                              }
                            >
                              {pager.publishStatus && pager.draftStatus
                                ? "Published"
                                : "Drafted"}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className={
                            lan === "rtl"
                              ? "form-group float-right"
                              : "form-group float-left"
                          }
                        >
                          <div dir={lan === "rtl" ? "rtl" : "ltr"}>
                            Created on: {parseISOString(pager.createdDate)}
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className={
                            lan === "rtl"
                              ? "form-group float-right"
                              : "form-group float-left"
                          }
                        >
                          <div dir={lan === "rtl" ? "rtl" : "ltr"}>
                            Last Edit :{parseISOString(pager.editedDate)}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div
                          className={
                            lan === "rtl"
                              ? "form-group float-right"
                              : "form-group float-left"
                          }
                        >
                          <div dir={lan === "rtl" ? "rtl" : "ltr"}>
                            {pager.publishStatus && pager.draftStatus
                              ? "Published On :" +
                                parseISOString(pager.editedDate)
                              : "Drafted on :" +
                                parseISOString(pager.editedDate)}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          {/* <button type="submit" className="btn btn-primary" style={{width:"100px",marginRight:'6px'}}>Draft</button> */}

                          {pager.draftStatus === true &&
                            pager.publishStatus === false && (
                              <>
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{ width: "100px", marginRight: "6px" }}
                                >
                                  Draft
                                </button>

                                {role.RFP === true && user.editor === true ? (
                                  <button
                                    type="#!"
                                    onClick={handlePublishRequest}
                                    className="btn btn-success"
                                    style={{
                                      width: "200px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Request to Publish
                                  </button>
                                ) : (
                                  <button
                                    type="#!"
                                    onClick={publish}
                                    className="btn btn-success"
                                    style={{
                                      width: "100px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Publish
                                  </button>
                                )}
                              </>
                            )}
                          {pager.draftStatus === true &&
                            pager.publishStatus === true &&
                            pager.republishStatus === false && (
                              <>
                                <button
                                  type="#!"
                                  onClick={redraft}
                                  className="btn btn-primary"
                                  style={{ width: "100px", marginRight: "6px" }}
                                >
                                  Redraft
                                </button>
                                {/* <button type="#!" onClick={republish} className="btn btn-success" style={{width:"100px",marginRight:'6px'}}>Republish</button> */}
                                {role.RFP === true && user.editor === true ? (
                                  <button
                                    type="#!"
                                    onClick={handleUnpublishRequest}
                                    className="btn btn-light"
                                    style={{
                                      width: "200px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Request to Unpublish
                                  </button>
                                ) : (
                                  <button
                                    type="#!"
                                    onClick={unpublish}
                                    className="btn btn-light"
                                    style={{
                                      width: "100px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Unpublish
                                  </button>
                                )}
                              </>
                            )}
                          {pager.draftStatus === true &&
                            pager.publishStatus === true &&
                            pager.republishStatus === true && (
                              <>
                                <button
                                  type="#!"
                                  onClick={redraft}
                                  className="btn btn-primary"
                                  style={{ width: "100px", marginRight: "6px" }}
                                >
                                  Redraft
                                </button>
                                {role.RFP === true && user.editor === true ? (
                                  <button
                                    type="#!"
                                    onClick={handleRepublishRequest}
                                    className="btn btn-success"
                                    style={{
                                      width: "200px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Request to Republish
                                  </button>
                                ) : (
                                  <button
                                    type="#!"
                                    onClick={republish}
                                    className="btn btn-success"
                                    style={{
                                      width: "100px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Republish
                                  </button>
                                )}
                                {role.RFP === true && user.editor === true ? (
                                  <button
                                    type="#!"
                                    onClick={handleUnpublishRequest}
                                    className="btn btn-light"
                                    style={{
                                      width: "200px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Request to Unpublish
                                  </button>
                                ) : (
                                  <button
                                    type="#!"
                                    onClick={unpublish}
                                    className="btn btn-light"
                                    style={{
                                      width: "100px",
                                      marginRight: "6px",
                                    }}
                                    disabled={
                                      !role.production === true ? true : false
                                    }
                                    hidden={
                                      !role.production === true ? true : false
                                    }
                                  >
                                    Unpublish
                                  </button>
                                )}
                              </>
                            )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          allimage={allImage}
        />
      </section>
    );
  }
};

export default TextPage;
